import { useTranslation } from 'react-i18next';

import { ArticleCard } from 'us-react-components/dist/ArticleCard/ArticleCard';
import { useDependencies } from '../../../../../dependencies';

const ARTICLES = [
  {
    imageUrl: 'https://assets.urbansitter.com/static/img/articles/dance-party.webp',
    linkUrl: 'https://blog.urbansitter.com/babysitting-rates/?utm_source=parent_dashboard',
    title: 'Average babysitting rates by city',
    altText: 'Dashboard dance party'
  },
  {
    imageUrl: 'https://assets.urbansitter.com/static/img/articles/caregiver-tent.webp',
    linkUrl: 'https://blog.urbansitter.com/preparing-kids-for-a-new-caregiver/?utm_source=parent_dashboard',
    title: 'How to prepare kids for a new caregiver',
    altText: 'Dashboard caregiver tent'
  },
  {
    imageUrl: 'https://assets.urbansitter.com/static/img/articles/couple-date-night.webp',
    linkUrl: 'https://blog.urbansitter.com/questions-to-ask-a-babysitter-in-an-interview/?utm_source=parent_dashboard',
    title: 'Interview questions to ask a caregiver',
    altText: 'Dashboard couple date night'
  },
  {
    imageUrl: 'https://assets.urbansitter.com/static/img/articles/caregiver-science-fun.webp',
    linkUrl: 'https://blog.urbansitter.com/when-you-need-last-minute-childcare/?utm_source=parent_dashboard',
    title: 'Tips to find backup care',
    altText: 'Dashboard caregiver science fun'
  },
  {
    imageUrl: 'https://assets.urbansitter.com/static/img/articles/parent-scooter.webp',
    linkUrl: 'https://blog.urbansitter.com/preparing-your-babysitter-for-an-emergency/?utm_source=parent_dashboard',
    title: 'Preparing your caregiver for emergencies',
    altText: 'Dashboard parent scooter'
  },
  {
    imageUrl: 'https://assets.urbansitter.com/static/img/articles/caregiver-beach.webp',
    linkUrl: 'https://blog.urbansitter.com/babysitting-checklist/?utm_source=parent_dashboard',
    title: 'Printable instructions for your caregiver',
    altText: 'Dashboard caregiver beach'
  }
]

export const ArticlesAndResources = (): JSX.Element => {
  const { services: { tracker } } = useDependencies();
  const { t } = useTranslation();

  const trackEvent = async (event: string, params?: {elementText: string}): Promise<void> => tracker.track(event, params);

  return (
    <div className='grid mb-20 hidden lg:block'>
      <span className='block font-bold mb-4'>{t('dashboard.widgets.articlesAndResources.label')}</span>
      <div className='flex flex-column gap-8'>
        {ARTICLES.map(article => (
          <div key={article.title}>
            <ArticleCard linkUrl={article.linkUrl} imageUrl={article.imageUrl} title={article.title} altText={article.altText} trackingCallback={trackEvent}/>
          </div>
        ))}
      </div>
    </div>
  );
};
